/* @minVersion 7.0.0-beta.0 */

export default function _classNameTDZError(name) {
  throw new ReferenceError(
    'Class "' + name + '" cannot be referenced in computed property keys.',
  );
}
